import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities' 

class LinkedPlatformRepository {
    constructor(){
        this.basePath = store.state.backend;
    }

    allLinkedPlatformsOfUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/linked-platform`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new LinkedPlatformRepository();
